import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Persists an estimate "Show Item" / "Show Price" checkbox the moment it's
// toggled, without reloading the page. The server returns 204 No Content.
export default class extends Controller {
  static values = { url: String, scope: String, id: Number, field: String }

  toggle(event) {
    this.persist(event.target.checked)
  }

  // Parent (inventory item) checkboxes cycle through three states:
  //   1st click: check the parent and all child instances
  //   2nd click: keep the parent checked, uncheck all children
  //   3rd click: uncheck the parent (children are already unchecked)
  // The state is read from the DOM, so mixed child states settle sensibly.
  cycle(event) {
    const children = this.childCheckboxes()
    let childState

    if (event.target.checked) {
      childState = "check"
    } else if (children.some((child) => child.checked)) {
      event.target.checked = true
      childState = "uncheck"
    } else {
      childState = "uncheck"
    }

    children.forEach((child) => { child.checked = childState === "check" })
    this.persist(event.target.checked, childState)
  }

  persist(checked, children = null) {
    const query = {
      scope: this.scopeValue,
      id: this.idValue,
      field: this.fieldValue,
      checked: checked
    }
    if (children) query.children = children

    patch(this.urlValue, { query: query, responseKind: "json" })
  }

  // Child checkboxes for the same field within this inventory item's card.
  childCheckboxes() {
    const card = this.element.closest('[data-estimate-filter-target="parent"]')
    if (!card) return []

    const selector = `input[type="checkbox"][data-estimate-visibility-field-value="${this.fieldValue}"]`
    return Array.from(card.querySelectorAll(selector))
      .filter((box) => box !== this.element && box.dataset.estimateVisibilityScopeValue !== "item")
  }
}
